import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["label", "source", "copyIcon", "doneIcon"]
  static values = { text: String, copied: String }

  connect() {
    this.originalLabel = this.labelTarget.textContent
  }

  disconnect() {
    clearTimeout(this.timeout)
  }

  async copy() {
    try {
      await navigator.clipboard.writeText(this.textValue)
      this._confirmCopied()
    } catch {
      this._selectSource()
    }
  }

  _confirmCopied() {
    this._showCopied(true)

    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => this._showCopied(false), 2000)
  }

  _showCopied(copied) {
    this.labelTarget.textContent = copied ? this.copiedValue : this.originalLabel
    this.copyIconTarget.classList.toggle("hidden", copied)
    this.doneIconTarget.classList.toggle("hidden", !copied)
  }

  _selectSource() {
    const range = document.createRange()
    range.selectNodeContents(this.sourceTarget)
    window.getSelection().removeAllRanges()
    window.getSelection().addRange(range)
  }
}
